export default __webpack_public_path__ + "static/media/icon-caution.616588eb.svg";